// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + ({"643":"pdfmake","2265":"canvg","4297":"xlsx"}[chunkId] || chunkId) + ".js";
};